const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  nameEn: state => state.user.nameEn,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,

  userId: state => state.user.userId,
  userIp: state => state.user.userIp,
  systemCode: state => state.user.systemCode,
  allDemand: state => state.app.allDemand,
  allTask: state => state.app.allTask,
  home: state => state.app.home,
  // projectId: state => state.app.projectId,
  actionUrl: state => state.user.actionUrl,
  urlInfo: state => state.user.urlInfo,
  tags: state => state.user.tags
}
export default getters
